import { useNavigate } from "@solidjs/router";
import { TextAndIconButton, TextButton } from "../components/button/Button";
import { directUserToSupport } from "../utils/supportUtil";
import { Title } from "@solidjs/meta";
import { useTranslation } from "../state/i18n";
import posthog from "posthog-js";
import { POSTHOG_EVENTS } from "../services/PostHogService.ts";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  posthog.capture(POSTHOG_EVENTS.PAGE_NOT_FOUND);

  return (
    <main class="mx-auto flex h-screen w-180 flex-col items-center pt-46 text-center">
      <Title>{t(($) => $.NOT_FOUND_PAGE_PAGE_TITLE)}</Title>
      <NotFoundImage />
      <h1 class="relative mt-16 mb-2 text-header-3xl text-primary">
        <span class="sr-only">404</span>
        {t(($) => $.NOT_FOUND_PAGE_TITLE)}
      </h1>
      <p class="mb-10 text-medium-regular text-secondary">{t(($) => $.NOT_FOUND_PAGE_DESCRIPTION)}</p>
      <div class="flex gap-x-2">
        <TextAndIconButton
          variant="primary"
          icon="home"
          text={t(($) => $.NOT_FOUND_PAGE_RETURN_HOME)}
          onClick={() => navigate("/")}
        />
        <TextButton
          variant="secondary"
          text={t(($) => $.NOT_FOUND_PAGE_CONTACT_SUPPORT)}
          onClick={directUserToSupport}
        />
      </div>
    </main>
  );
};

export default NotFoundPage;

const NotFoundImage = () => (
  <svg
    class="shrink-0 icon-brand"
    aria-hidden="true"
    width="280"
    height="106"
    viewBox="0 0 280 106"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M195.38 86.626V69.1484L239.202 0.109375H254.271V24.3012H245.352L217.727 68.0209V68.8409H280V86.626H195.38ZM245.763 105.077V81.2956L246.173 73.5563V0.109375H266.982V105.077H245.763Z"
      fill="currentColor"
    />
    <path
      d="M0 86.626V69.1484L43.8221 0.109375H58.8908V24.3012H49.9726L22.3467 68.0209V68.8409H84.6203V86.626H0ZM50.3826 105.077V81.2956L50.7927 73.5563V0.109375H71.6018V105.077H50.3826Z"
      fill="currentColor"
    />
    <path
      d="M144.406 34.9929V0C148.134 4.44382 153.715 11.5958 159.109 20.3788L144.406 34.9929ZM135.595 47.3764L116.366 28.2697C113.753 33.184 111.347 38.4434 109.404 43.9085L135.595 69.9336V47.3764ZM144.406 47.3764V69.9336L170.596 43.9085C168.653 38.4434 166.247 33.184 163.634 28.2697L144.406 47.3764ZM144.406 82.317V105.087C161.792 102.821 175.251 87.3534 175.251 68.5917C175.251 63.524 174.574 58.4598 173.42 53.4897L144.406 82.317ZM106.58 53.4897C105.426 58.4598 104.75 63.524 104.75 68.5917C104.75 87.3534 118.208 102.821 135.595 105.087V82.317L106.58 53.4897ZM135.595 34.9929V0C131.866 4.44382 126.286 11.5958 120.891 20.3788L135.595 34.9929Z"
      fill="currentColor"
    />
  </svg>
);
